export default {
  info_modal: {
    outside_delivery_radius: {
      title: "Adresse außerhalb unseres Lieferradius",
      description:
        "Deine Adresse liegt außerhalb unseres Lieferradius. Bitte ändere deine Adresse oder wechsle zu einer Bestellung zur Abholung.",
      button_title: "Weiter",
    },
    location_not_found: {
      title: "Adresse nicht gefunden",
      description:
        "Leider konnten wir diese Adresse nicht finden. Bitte versuche es erneut, indem du zuerst die Straße im Suchfeld eingibst.",
      button_title: "Weiter",
    },
  },
};
